import Header from "../../shared/ArtistHeader/header";
import Footer from "../../shared/footer/footer";
import ContactUsComponent from "../../shared/contactUs/contactUsComponent";

const ContactUs = () => {
	return (
		<div>
			{/* <Header /> */}
			<ContactUsComponent />
			{/* <Footer /> */}
		</div>
	);
};

export default ContactUs;
